// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* background-color: #f5f5f5; */
.pdfDisplayDiv {
    background-color: white;
    width: 70%;
    min-height: 84vh;
    margin: auto;
    margin-top: 2%;
    margin-bottom: 4% !important;
    padding-left: 2%;
    padding-right: 0% !important;
    padding-top: 0% !important;
    padding-bottom: 0% !important;
    overflow: auto;
    max-height: 84vh;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 5px;
    height: 84vh;
}

.temp4MainDiv{
    /* background-color: aqua; */
    min-height: 84vh;
    width: 100%;
}
.temp4LeftCol{
    background-color: white;
    /* background-color: #d9e6eb; */
    text-align: left !important;
    min-height: 84vh;
    padding: 0%;
}
.leftInnerColoumn{
     background-color: #d9e6eb;
     /* background-color: red; */
    padding-top:5%;
    padding-left: 6% !important;
    color: #505252;
    font-size: 6px;
    min-height: 84vh;
    margin-left: 12%;
    height:100%;
}
.temp4BlueFont{
    color: #254a59;
    margin-top: 12% !important;
}
.temp4RightCol{
    /* background-color: #082d4d; */
    min-height: 84vh;
    padding:0 !important;
    margin: 0;
    padding-top: 0% !important;
    color: #505252;
}

.profileName {
    padding: 0;
    margin: 0;
    padding-left: 4%;
    position: relative;
    font-weight: 520;
    color: rgb(30, 37, 50);
    color: rgb(22, 89, 143);
    font-size: 10px;
}
.temp4NameDiv {
   /* background-color: #a9c9d7; */
   width: 100% !important;
   padding-top: 8% !important;
   padding-left: 6% !important;
   padding-right: 4% !important;
}
.temp4ResumeName{
    font-size: 14px !important;
    font-weight: 640;
    margin-top: 1% !important;
    padding-top: 0% !important;
    letter-spacing: 4px;
    color: #2f4d5b;
}
.temp4Hr{
    width: 17%;
    margin-top: 6%;
    margin-bottom: 8%;
}
.temp4Hr2{
    width: 17%;
    margin-top: 4%;
    margin-bottom: 5%;
    margin-left: 4%;
}
.temp4ResumeTitle{
    font-weight: 500;
    font-size: 8px  !important;
    letter-spacing: 1.6px;
    margin-bottom: 5%;
    margin-left: 3.5% !important;
    color: #2f4d5b;

}
.temp4ProfessionalSummary{
    margin-left: -2%;
}
.temp2GreyFont{
    margin-top: 12% !important;
    /* color: rgb(144, 154, 178) !important; */
    color: #62a844 !important;

}
.temp2PersonalDetails{
    font-size: 10px !important;
}
.temp4ProfileDetails{
    padding-left: 2%;
    margin-top: 22% !important;
    padding-right: 12% !important;
}
.temp4ImageDiv{
   margin: auto;
    margin-top: 18%;
    width: 100%;
    align-items: center !important;
    text-align: center;
    height: 70px;
}
.imageBg{
    background-color: #a9c9d7;
    border-radius: 100%;
    /* margin: auto; */
    margin-left: 8%;
    width: 70px;
    padding: 3%;
    height: 69px;
}
.temp4DisplayImage{
    width: 63px !important;
    border-radius: 100%;
    height: 63px;
}
.temp3PersonalDetails{
    font-size: 10px;
}
.temp3Underline{
    /* text-decoration: underline; */
   /* color: rgb(22, 89, 143); */
   color: rgb(26, 145, 240);

}
.temp3Headings{
    color: rgb(30, 37, 50);
    /* color: #62a844; */

}
.temp3ProfileName{
    color: rgb(30, 37, 50) !important;
    /* color: #62a844 !important;  */


}
.temp4BlueFont{
    font-weight: 750 !important;
    letter-spacing: 2px;
    margin-top: 29% !important;
}
.template4RightHeadings{
    margin-top: 10% !important;
    font-weight: 700 !important;
    letter-spacing: 2px;
}
.temp4GreyBigDiv{
    background-color: #f5f5f5;
    width: 100%;
    position: relative;
    top: 3%;
}
.temp4LeftContent{
    margin-top: 15%;
    padding-left: 6%;
    padding-right: 4%;
}
.employmetnProfileText{
padding-left: 4% !important;
}
.profileEmploymentName{
    padding-left: 4% !important;
}
.employmentTime {
    padding-left: 4% !important;
}
.temp3Hr3{
    width: 20%;
    margin-left: 4% !important;
    margin: 0%;
    padding: 0%;
    margin-top: 3%;
    margin-bottom: 5%;
}
.temp4CustomTitle{
    margin-left: -1%;
}
.employmentHistName{
margin-top: 1%;
}

/* Media query for mobile view */
@media screen and (max-width: 890px) {
    .temp4RightCol {
        width: 66%; /* Full width for both columns */
        /* padding-top: 5%;  */
        /* padding-left: 5%; */
    }

    .temp4LeftCol {
        width: 33%; /* Full width for both columns */
        /* padding-top: 5%;  */
        /* right: -6.8%; */
    }
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/temp4.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;AACf;AACA;KACK,yBAAyB;KACzB,2BAA2B;IAC5B,cAAc;IACd,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;AACA;GACG,+BAA+B;GAC/B,sBAAsB;GACtB,0BAA0B;GAC1B,2BAA2B;GAC3B,4BAA4B;AAC/B;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;;AAElB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,0CAA0C;IAC1C,yBAAyB;;AAE7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;GACG,YAAY;IACX,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,gCAAgC;GACjC,6BAA6B;GAC7B,wBAAwB;;AAE3B;AACA;IACI,sBAAsB;IACtB,oBAAoB;;AAExB;AACA;IACI,iCAAiC;IACjC,gCAAgC;;;AAGpC;AACA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;AACA,2BAA2B;AAC3B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,UAAU;IACV,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;AACA,cAAc;AACd;;AAEA,gCAAgC;AAChC;IACI;QACI,UAAU,EAAE,gCAAgC;QAC5C,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,UAAU,EAAE,gCAAgC;QAC5C,sBAAsB;QACtB,kBAAkB;IACtB;AACJ","sourcesContent":["/* background-color: #f5f5f5; */\n.pdfDisplayDiv {\n    background-color: white;\n    width: 70%;\n    min-height: 84vh;\n    margin: auto;\n    margin-top: 2%;\n    margin-bottom: 4% !important;\n    padding-left: 2%;\n    padding-right: 0% !important;\n    padding-top: 0% !important;\n    padding-bottom: 0% !important;\n    overflow: auto;\n    max-height: 84vh;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 5px;\n    height: 84vh;\n}\n\n.temp4MainDiv{\n    /* background-color: aqua; */\n    min-height: 84vh;\n    width: 100%;\n}\n.temp4LeftCol{\n    background-color: white;\n    /* background-color: #d9e6eb; */\n    text-align: left !important;\n    min-height: 84vh;\n    padding: 0%;\n}\n.leftInnerColoumn{\n     background-color: #d9e6eb;\n     /* background-color: red; */\n    padding-top:5%;\n    padding-left: 6% !important;\n    color: #505252;\n    font-size: 6px;\n    min-height: 84vh;\n    margin-left: 12%;\n    height:100%;\n}\n.temp4BlueFont{\n    color: #254a59;\n    margin-top: 12% !important;\n}\n.temp4RightCol{\n    /* background-color: #082d4d; */\n    min-height: 84vh;\n    padding:0 !important;\n    margin: 0;\n    padding-top: 0% !important;\n    color: #505252;\n}\n\n.profileName {\n    padding: 0;\n    margin: 0;\n    padding-left: 4%;\n    position: relative;\n    font-weight: 520;\n    color: rgb(30, 37, 50);\n    color: rgb(22, 89, 143);\n    font-size: 10px;\n}\n.temp4NameDiv {\n   /* background-color: #a9c9d7; */\n   width: 100% !important;\n   padding-top: 8% !important;\n   padding-left: 6% !important;\n   padding-right: 4% !important;\n}\n.temp4ResumeName{\n    font-size: 14px !important;\n    font-weight: 640;\n    margin-top: 1% !important;\n    padding-top: 0% !important;\n    letter-spacing: 4px;\n    color: #2f4d5b;\n}\n.temp4Hr{\n    width: 17%;\n    margin-top: 6%;\n    margin-bottom: 8%;\n}\n.temp4Hr2{\n    width: 17%;\n    margin-top: 4%;\n    margin-bottom: 5%;\n    margin-left: 4%;\n}\n.temp4ResumeTitle{\n    font-weight: 500;\n    font-size: 8px  !important;\n    letter-spacing: 1.6px;\n    margin-bottom: 5%;\n    margin-left: 3.5% !important;\n    color: #2f4d5b;\n\n}\n.temp4ProfessionalSummary{\n    margin-left: -2%;\n}\n.temp2GreyFont{\n    margin-top: 12% !important;\n    /* color: rgb(144, 154, 178) !important; */\n    color: #62a844 !important;\n\n}\n.temp2PersonalDetails{\n    font-size: 10px !important;\n}\n.temp4ProfileDetails{\n    padding-left: 2%;\n    margin-top: 22% !important;\n    padding-right: 12% !important;\n}\n.temp4ImageDiv{\n   margin: auto;\n    margin-top: 18%;\n    width: 100%;\n    align-items: center !important;\n    text-align: center;\n    height: 70px;\n}\n.imageBg{\n    background-color: #a9c9d7;\n    border-radius: 100%;\n    /* margin: auto; */\n    margin-left: 8%;\n    width: 70px;\n    padding: 3%;\n    height: 69px;\n}\n.temp4DisplayImage{\n    width: 63px !important;\n    border-radius: 100%;\n    height: 63px;\n}\n.temp3PersonalDetails{\n    font-size: 10px;\n}\n.temp3Underline{\n    /* text-decoration: underline; */\n   /* color: rgb(22, 89, 143); */\n   color: rgb(26, 145, 240);\n\n}\n.temp3Headings{\n    color: rgb(30, 37, 50);\n    /* color: #62a844; */\n\n}\n.temp3ProfileName{\n    color: rgb(30, 37, 50) !important;\n    /* color: #62a844 !important;  */\n\n\n}\n.temp4BlueFont{\n    font-weight: 750 !important;\n    letter-spacing: 2px;\n    margin-top: 29% !important;\n}\n.template4RightHeadings{\n    margin-top: 10% !important;\n    font-weight: 700 !important;\n    letter-spacing: 2px;\n}\n.temp4GreyBigDiv{\n    background-color: #f5f5f5;\n    width: 100%;\n    position: relative;\n    top: 3%;\n}\n.temp4LeftContent{\n    margin-top: 15%;\n    padding-left: 6%;\n    padding-right: 4%;\n}\n.employmetnProfileText{\npadding-left: 4% !important;\n}\n.profileEmploymentName{\n    padding-left: 4% !important;\n}\n.employmentTime {\n    padding-left: 4% !important;\n}\n.temp3Hr3{\n    width: 20%;\n    margin-left: 4% !important;\n    margin: 0%;\n    padding: 0%;\n    margin-top: 3%;\n    margin-bottom: 5%;\n}\n.temp4CustomTitle{\n    margin-left: -1%;\n}\n.employmentHistName{\nmargin-top: 1%;\n}\n\n/* Media query for mobile view */\n@media screen and (max-width: 890px) {\n    .temp4RightCol {\n        width: 66%; /* Full width for both columns */\n        /* padding-top: 5%;  */\n        /* padding-left: 5%; */\n    }\n\n    .temp4LeftCol {\n        width: 33%; /* Full width for both columns */\n        /* padding-top: 5%;  */\n        /* right: -6.8%; */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
